module.exports = __webpack_public_path__ + "static/bbb-working-3a553cd14130cd1ea6b062da3a2f4c4e.png";